import GoogleLogo from 'assets/logos/google_logo.png';
import RetenticsLogin from 'assets/logos/retentics_login_logo.png';
import Retentics from 'assets/logos/retentics_logo.png';

export const GOOGLE_LOGO = GoogleLogo;
export const RETENTICS_LOGIN_LOGO = RetenticsLogin;
export const RETENTICS_LOGO = Retentics;
